export default __webpack_public_path__ + "static/media/milestone-tier-1.d33e40d1.png";